import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { EMPTY, merge, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { UserReport, UserService } from 'src/app/core';
import { SubSink } from 'subsink';
import { AdminDocumentPreviewComponent } from '../dialogs/admin-document-preview/admin-document-preview.component';

@Component({
  selector: 'admin-user-shared-files-list',
  templateUrl: './admin-user-shared-files-list.component.html',
  styleUrls: ['./admin-user-shared-files-list.component.sass'],
})
export class AdminUserSharedFilesListComponent implements OnInit {
  @Input('userReport') userReport!: UserReport;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('type') documentTypes!: MatSelect;

  public refreshController = new Subject();

  public isRateLimitReached: boolean = false;
  public isLoadingResult: boolean = false;
  public resultsLength: number = 0;

  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: string[] = ['id', 'name', 'date', 'user', 'actions'];

  // ------------------------------------------------Private methods|

  private subsink = new SubSink();
  private previewDialogRef!: MatDialogRef<AdminDocumentPreviewComponent>;

  // ------------------------------------------------Constructor|

  constructor(private userService: UserService, private dialogBox: MatDialog, private cdr: ChangeDetectorRef) {}
  public getDate(date: string): Date {
    return new Date(date);
  }
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;

    merge(
      this.paginator.page,
      this.refreshController,
      this.documentTypes.valueChange
    )
      .pipe(
        startWith({}),
        switchMap((value: any, index: any) => {
          this.isLoadingResult = true;
          this.cdr.detectChanges();
          return this.userService
            .getUserSharedFiles(this.userReport.user_id, {
              page: this.paginator.pageIndex + 1,
              limit: this.paginator.pageSize,
              confirmed: this.documentTypes?.value,
            })
            .pipe(catchError(() => EMPTY));
        }),
        map((data) => {
          this.isLoadingResult = false;
          this.isRateLimitReached = data.items.length === 0;
          this.cdr.detectChanges();
          if (this.isRateLimitReached) {
            return [];
          }

          this.resultsLength = data.meta.totalItems + 1;
          return data.items;
        })
      )
      .subscribe((data) => (this.dataSource = new MatTableDataSource(data)));
  }

  // ---------------------------------------------------------Public methods|

  /**
   * Simply opens a new dialog and shows completed data
   * to admin or manager.
   */
  preview(id: number) {
    const target = this.dataSource.data.filter((item) => {
      return item.id === id;
    });

    if (!(target.length > 0)) {
      throw new Error('Target is empty on review method');
    }

    this.previewDialogRef = this.dialogBox.open(AdminDocumentPreviewComponent, {
      data: target[0],
      width: '100%',
      maxWidth: '800px',
    });

    this.subsink.sink = this.previewDialogRef.afterClosed().subscribe(() => {
      this.refreshController.next('');
    });
  }
}
